module.exports = __webpack_public_path__ + "static/media/start-lines.2f207fe1.png";